import React, { useState, useEffect, useRef } from 'react';
import JSConfetti from 'js-confetti';
import { logos } from '../utils/logos.js';
import { styles } from '../assets/styles';
import { Clock } from './clock.js';
import { ShareResultsClassic, ShareResultsCopyCries, ShareResultsCopyEmoji } from './share.js';
import '../assets/animations.css';
import {
  averageFetchPerGame,
  averageFetchPerGameCries,
  averageFetchPerGameEmoji,
} from '../utils/averageFetches.js';
import { WinnerBox } from './containers.js';

const iconChanging = (winCountPosta) => {
  if (winCountPosta >= 1 && winCountPosta <= 10) {
    return logos.pokeBall;
  }
  if (winCountPosta >= 11 && winCountPosta <= 20) {
    return logos.superBall;
  }
  if (winCountPosta >= 21 && winCountPosta <= 30) {
    return logos.ultraBall;
  }
  if (winCountPosta >= 31 && winCountPosta <= 10000) {
    return logos.masterBall;
  }
};

const jsConfetti = new JSConfetti();

const dateTimeWorldApiFetchArgentina = new Date(
  new Date().toLocaleString('en-US', {
    timeZone: 'America/Argentina/Buenos_Aires',
  }),
);

const dayName = dateTimeWorldApiFetchArgentina.toLocaleString('en-US', {
  weekday: 'long',
});
const day = dateTimeWorldApiFetchArgentina.getDate().toString().padStart(2, '0');
const month = (dateTimeWorldApiFetchArgentina.getMonth() + 1).toString().padStart(2, '0');
const year = dateTimeWorldApiFetchArgentina.getFullYear().toString();
const hour = dateTimeWorldApiFetchArgentina.getHours().toString().padStart(2, '0');
const minute = dateTimeWorldApiFetchArgentina.getMinutes().toString().padStart(2, '0');

export function WinnerLetter({ pokemonInfo, fetchCount }) {
  const [showInfo, setShowInfo] = useState(false);
  const [winner, setWinner] = useState(false);
  const [gifUrl, setGifUrl] = useState(null);
  const [winnerUpdated, setWinnerUpdated] = useState(false);
  const [hasWonToday, setHasWonToday] = useState(false);
  const [fetchCounts, setFetchCounts] = useState(() => {
    const storedFetchCounts = localStorage.getItem('total_fetches');
    return storedFetchCounts ? JSON.parse(storedFetchCounts) : [];
  });

  const [stats, setStats] = useState(() => {
    const storedStats = localStorage.getItem('stats_classic');
    return storedStats ? JSON.parse(storedStats) : { avgGuesses: 0, winCount: 0 };
  });
  const { avgGuesses, winCount: winCountPosta } = stats;

  const storedFetchCount = localStorage.getItem('fetch_count');
  fetchCount = storedFetchCount ? parseInt(storedFetchCount) : 0;

  const gifRef = useRef(null);
  const dateString = `${dayName} ${hour}:${minute} ${day}/${month}/${year} `;
  localStorage.setItem('current_date', dateString);

  useEffect(() => {
    async function loadGif() {
      const { default: gif } = await import(
        `../assets/animated/${pokemonInfo.id.toString().padStart(3, '0')}.gif`
      );
      setGifUrl(gif);
    }
    loadGif();

    const storedHasWonToday = localStorage.getItem('has_won');
    if (storedHasWonToday) {
      setHasWonToday(true);
    }
  }, [pokemonInfo.id]);

  const tryText = fetchCount === 1 ? 'try' : 'tries';

  useEffect(() => {
    setShowInfo(true);
    if (!hasWonToday && winner) {
      setStats((prevStats) => ({
        ...prevStats,
        winCount: prevStats.winCount + 1,
        avgGuesses: averageFetchPerGame(),
      }));
      setHasWonToday(true);
      localStorage.setItem('has_won', true);
      localStorage.setItem('total_fetches', JSON.stringify(fetchCounts));
      setTimeout(() => {
        gifRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 3600);
      setTimeout(() => {
        jsConfetti.addConfetti({
          emojis: ['🌊', '🍃', '🔥', '⚡️', '💥'],
          emojiSize: 50,
          confettiNumber: 50,
          confettiRadius: 8,
        });
      }, 4450);
    }
    if (winner) {
      setTimeout(() => {
        gifRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 3600);
    }
  }, [winner, avgGuesses, pokemonInfo, fetchCount, hasWonToday, fetchCounts]);

  useEffect(() => {
    if (
      pokemonInfo.colorGeneration === '#a4ff91'
      && pokemonInfo.colorTypes === '#a4ff91'
      && pokemonInfo.colorWeight === '#a4ff91'
      && pokemonInfo.colorHeight === '#a4ff91'
      && pokemonInfo.colorTotalStats === '#a4ff91'
    ) {
      if (!winnerUpdated) {
        setWinner(true);
        setWinnerUpdated(true);
        localStorage.setItem('has_won', true);
        setFetchCounts((prevCounts) => [...prevCounts, fetchCount]);
      }
    } else {
      setWinnerUpdated(false);
    }
  }, [pokemonInfo, fetchCount, winnerUpdated]);

  const iconWinner = iconChanging(winCountPosta);

  useEffect(() => {
    localStorage.setItem('stats_classic', JSON.stringify(stats));
  }, [stats]);

  return (
    <>
      {winner && (
        <>
          <WinnerBox gifRef={gifRef}>
            <div style={styles.winnerLetterCenterTopContainer}>
              {/* Sección separada para el elemento "winner" */}
              <div style={styles.winnerLetterTopContainer}>
                <img src={gifUrl} alt="Pkmn Gif" style={styles.winnerLetterImgMargin} />
                <div style={styles.winnerLetterTopContainer2}>
                  <h1 style={styles.winnerLetterText}>You ,,,,guessed,</h1>
                  <h2 style={styles.winnerLetterPokeName}>{pokemonInfo.name}</h2>
                  In,,,
                  {fetchCount}
                  ,,,
                  {tryText}
                </div>
              </div>
            </div>

            <div style={styles.winnerLetterWinsContainer}>
              <span style={styles.winnerLetterTotalWinsMargin}>
                <img src={iconWinner} style={styles.winnerLetterImg} />
                Total ,,,, wins:
              </span>
              <span style={styles.winnerLetterWincountSpan}>
                <p style={styles.winnerLetterWincountColor}>{winCountPosta}</p>
              </span>
              <img src={iconWinner} style={styles.winnerLetterBallImg} />
            </div>
            <Clock />
            <div style={styles.winnerLetterHrefContainer}>
              <a href="/cries" className="cries" style={styles.winnerLetterAHref}>
                <img src={logos.playIcon} style={styles.winnerLetterIconMargin} />
                <div style={styles.winnerLetterTextContainer}>
                  <span style={styles.winnerLetterSpan}>CRIES</span>
                  <span style={styles.winnerLetterHrefSpan}>Guess a POKéMON by its cry</span>
                </div>
              </a>
            </div>
          </WinnerBox>
          <ShareResultsClassic />
        </>
      )}
    </>
  );
}

export function WinnerLetterCries({ pokemonInfoCries, fetchCountCries }) {
  let pokemonname = '';
  let date = '';
  const guessedPokemonList = [];
  const [showInfo, setShowInfo] = useState(false);
  const [winner, setWinner] = useState(false);
  const [gifUrl, setGifUrl] = useState(null);
  const [winnerUpdated, setWinnerUpdated] = useState(false);
  const [hasWonToday, setHasWonToday] = useState(false);
  const [fetchCounts, setFetchCounts] = useState(() => {
    const storedFetchCounts = localStorage.getItem('total_fetches_cries');
    return storedFetchCounts ? JSON.parse(storedFetchCounts) : [];
  });

  const [stats, setStats] = useState(() => {
    const storedStats = localStorage.getItem('stats_cries');
    return storedStats ? JSON.parse(storedStats) : { avgGuesses: 0, winCount: 0 };
  });
  const { avgGuesses } = stats;
  const winCountPosta = stats.winCount;

  const storedFetchCount = localStorage.getItem('fetch_count_cries');
  fetchCountCries = storedFetchCount ? parseInt(storedFetchCount) : 0;

  const gifRef = useRef(null);
  const dateString = `${dayName} ${hour}:${minute} ${day}/${month}/${year} `;
  localStorage.setItem('current_date_cries', dateString);

  useEffect(() => {
    async function loadGif() {
      const { default: gif } = await import(
        `../assets/animated/${pokemonInfoCries.id.toString().padStart(3, '0')}.gif`
      );
      setGifUrl(gif);
    }
    loadGif();

    const storedHasWonToday = localStorage.getItem('has_won_cries');
    if (storedHasWonToday) {
      setHasWonToday(true);
    }
  }, [pokemonInfoCries.id]);

  const submitButton = document.getElementById('submit');

  useEffect(() => {
    setShowInfo(true);
    if (!hasWonToday && winner) {
      setStats((prevStats) => ({
        ...prevStats,
        winCount: prevStats.winCount + 1,
        avgGuesses: averageFetchPerGameCries(),
      }));
      setHasWonToday(true); // actualiza el estado
      localStorage.setItem('has_won_cries', true); // almacena el estado en localStorage
      localStorage.setItem('total_fetches_cries', JSON.stringify(fetchCounts));
      setTimeout(() => {
        gifRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 1100);
      setTimeout(() => {
        jsConfetti.addConfetti({
          emojis: ['🌊', '🍃', '🔥', '⚡️', '💥'],
          emojiSize: 50,
          confettiNumber: 50,
          confettiRadius: 8,
        });
      }, 2500);
    }
    if (winner) {
      setTimeout(() => {
        gifRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 1100);
    }
  }, [winner, avgGuesses, pokemonInfoCries]);

  useEffect(() => {
    if (pokemonInfoCries.colorName === '#a4ff91') {
      if (!winnerUpdated) {
        setWinner(true);
        setWinnerUpdated(true);
        localStorage.setItem('has_won_cries', true);
        setFetchCounts((prevCounts) => [...prevCounts, fetchCountCries]);
        submitButton.disabled = true;
        pokemonname = pokemonInfoCries.name;
        date = dateString;
        guessedPokemonList.push(pokemonInfoCries.name);
      }
    } else {
      setWinnerUpdated(false);
    }
  }, [pokemonInfoCries, fetchCountCries, winnerUpdated]);

  const iconWinner = iconChanging(winCountPosta);
  const tryText = fetchCountCries === 1 ? 'try' : 'tries';

  averageFetchPerGameCries();

  useEffect(() => {}, [fetchCounts]);

  useEffect(() => {
    localStorage.setItem('stats_cries', JSON.stringify(stats));
  }, [stats]);

  return (
    <>
      {winner && (
        <>
          <WinnerBox gifRef={gifRef}>
            <div style={styles.winnerLetterCenterTopContainer}>
              <div style={styles.winnerLetterTopContainer}>
                <img src={gifUrl} alt="Pkmn Gif" style={styles.winnerLetterImgMargin} />
                <div style={styles.winnerLetterTopContainer2}>
                  <h1 style={styles.winnerLetterText}>You ,,,,guessed,</h1>
                  <h2 style={styles.winnerLetterPokeName}>{pokemonInfoCries.name}</h2>
                  In,,,
                  {fetchCountCries}
                  ,,,
                  {tryText}
                </div>
              </div>
            </div>

            <div style={styles.winnerLetterWinsContainer}>
              <span style={styles.winnerLetterTotalWinsMargin}>
                <img src={iconWinner} style={styles.winnerLetterImg} />
                Total ,,,, wins:
              </span>
              <span style={styles.winnerLetterWincountSpan}>
                <p style={styles.winnerLetterWincountColor}>{winCountPosta}</p>
              </span>
              <img src={iconWinner} style={styles.winnerLetterBallImg} />
            </div>
            <Clock />
            <div style={styles.winnerLetterHrefContainer}>
              <a href="/emoji" className="emoji" style={styles.winnerLetterAHrefCries}>
                <img src={logos.emojiIcon} style={styles.winnerLetterEmojiIconMargin} />
                <div style={styles.winnerLetterTextContainer}>
                  <span style={styles.winnerLetterSpan}>EMOJI</span>
                  <span style={styles.winnerLetterHrefSpan}>
                    Guess a POKéMON with a set of emojis
                  </span>
                </div>
              </a>
            </div>
          </WinnerBox>
          <ShareResultsCopyCries />
        </>
      )}
    </>
  );
}

export function WinnerLetterEmoji({ pokemonInfoEmoji, fetchCountEmoji }) {
  let pokemonname = '';
  let date = '';
  const guessedPokemonList = [];
  const [showInfo, setShowInfo] = useState(false);
  const [winner, setWinner] = useState(false);
  const [gifUrl, setGifUrl] = useState(null);
  const [winnerUpdated, setWinnerUpdated] = useState(false);
  const [hasWonToday, setHasWonToday] = useState(false);
  const [fetchCounts, setFetchCounts] = useState(() => {
    const storedFetchCounts = localStorage.getItem('total_fetches_emoji');
    return storedFetchCounts ? JSON.parse(storedFetchCounts) : [];
  });

  const [stats, setStats] = useState(() => {
    const storedStats = localStorage.getItem('stats_emoji');
    return storedStats ? JSON.parse(storedStats) : { avgGuesses: 0, winCount: 0 };
  });
  const { avgGuesses } = stats;
  const winCountPosta = stats.winCount;

  const storedFetchCount = localStorage.getItem('fetch_count_emoji');
  fetchCountEmoji = storedFetchCount ? parseInt(storedFetchCount) : 0;

  const gifRef = useRef(null);
  const dateString = `${dayName} ${hour}:${minute} ${day}/${month}/${year} `;
  localStorage.setItem('current_date_emoji', dateString);

  useEffect(() => {
    async function loadGif() {
      const { default: gif } = await import(
        `../assets/animated/${pokemonInfoEmoji.id.toString().padStart(3, '0')}.gif`
      );
      setGifUrl(gif);
    }
    loadGif();

    const storedHasWonToday = localStorage.getItem('has_won_emoji');
    if (storedHasWonToday) {
      setHasWonToday(true);
    }
  }, [pokemonInfoEmoji.id]);

  const submitButton = document.getElementById('submit');

  useEffect(() => {
    setShowInfo(true);
    if (!hasWonToday && winner) {
      setStats((prevStats) => ({
        ...prevStats,
        winCount: prevStats.winCount + 1,
        avgGuesses: averageFetchPerGameEmoji(),
      }));
      setHasWonToday(true); // actualiza el estado
      localStorage.setItem('has_won_emoji', true); // almacena el estado en localStorage
      localStorage.setItem('total_fetches_emoji', JSON.stringify(fetchCounts));
      setTimeout(() => {
        gifRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 1100);
      setTimeout(() => {
        jsConfetti.addConfetti({
          emojis: ['🌊', '🍃', '🔥', '⚡️', '💥'],
          emojiSize: 50,
          confettiNumber: 50,
          confettiRadius: 8,
        });
      }, 2500);
    }
    if (winner) {
      setTimeout(() => {
        gifRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 1100);
    }
  }, [winner, avgGuesses, pokemonInfoEmoji]);

  useEffect(() => {
    if (pokemonInfoEmoji.colorName === '#a4ff91') {
      if (!winnerUpdated) {
        setWinner(true);
        setWinnerUpdated(true);
        localStorage.setItem('has_won_emoji', true);
        setFetchCounts((prevCounts) => [...prevCounts, fetchCountEmoji]);
        submitButton.disabled = true;
        pokemonname = pokemonInfoEmoji.name;
        date = dateString;
        guessedPokemonList.push(pokemonInfoEmoji.name);
      }
    } else {
      setWinnerUpdated(false);
    }
  }, [pokemonInfoEmoji, fetchCountEmoji, winnerUpdated]);

  const iconWinner = iconChanging(winCountPosta);
  const tryText = fetchCountEmoji === 1 ? 'try' : 'tries';

  averageFetchPerGameEmoji();

  useEffect(() => {}, [fetchCounts]);

  useEffect(() => {
    localStorage.setItem('stats_emoji', JSON.stringify(stats));
  }, [stats]);

  return (
    <>
      {winner && (
        <>
          <WinnerBox gifRef={gifRef}>
            <div style={styles.winnerLetterCenterTopContainer}>
              <div style={styles.winnerLetterTopContainer}>
                <img src={gifUrl} alt="Pkmn Gif" style={{ marginRight: '35px' }} />
                <div style={styles.winnerLetterTopContainer2}>
                  <h1 style={styles.winnerLetterText}>You ,,,,guessed,</h1>
                  <h2 style={styles.winnerLetterPokeName}>{pokemonInfoEmoji.name}</h2>
                  In,,,
                  {fetchCountEmoji}
                  ,,,
                  {tryText}
                </div>
              </div>
            </div>

            <div style={styles.winnerLetterWinsContainer}>
              <span style={styles.winnerLetterIconMargin}>
                <img src={iconWinner} style={styles.winnerLetterImg} />
                Total ,,,, wins:
              </span>
              <span style={styles.winnerLetterWincountSpan}>
                <p style={styles.winnerLetterWincountColor}>{winCountPosta}</p>
              </span>
              <img src={iconWinner} style={styles.winnerLetterBallImg} />
            </div>
            <Clock />
            <div style={styles.winnerLetterHrefContainer}>
              <a href="/" className="emoji" style={styles.winnerLetterAHref}>
                <div style={styles.winnerLetterTextContainer}>
                  <span style={styles.winnerLetterHrefSpan}>Go back to menu</span>
                </div>
              </a>
            </div>
          </WinnerBox>
          <ShareResultsCopyEmoji />
        </>
      )}
    </>
  );
}
